import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
function Committees() {
  return (
    <>
      <Header />
      <div className="section">
        {/* <!--Video Section--> */}
        <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
          <div class="pattern-overlay">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 title-heading">
                  <h2>Committees 2026-2027</h2>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="content-section py-5">
          <div className="container">
            <div className="row">
              {/* 01. Internal Quality Assurance Cell (IQAC/NAAC Committee) */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Internal Quality Assurance Cell (IQAC/NAAC Committee)
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Principal : Chairperson</li>
                      <li>Dr. Uma Rani : Convenor</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Prof. Gurjeet Kaur</li>
                      <li>Prof. Ramesh Kumar</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                      <li>Dr. Abhilasha Sharda (Retired Principal)</li>
                      <li>Dr. Y.P. Saini (Retired Principal)</li>
                      <li>Sh. Rajeev Kumar (Supdt. G-1)</li>
                      <li>President CSCA 2025-26</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 02. General Purchase Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">General Purchase Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Dr. Butta Ram</li>
                      <li>Prof. Ramesh Kumar</li>
                      <li>Sh. Rajeev Kumar (G-1)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 03. Career Counselling and Placement Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Career Counselling and Placement Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Principal : Head</li>
                      <li>Dr. Uma Rani : Deputy Head</li>
                      <li>Dr. Gaurav Sharma : RUSA Coordinator</li>
                      <li>Dr. Richa Sharma : Member (Science Faculty)</li>
                      <li>Prof. Gurmel Singh : Member (Arts Faculty)</li>
                      <li>Prof. Gurjeet Kaur : Member (Commerce Faculty)</li>
                      <li>Sh. Ashok Kumar : Representative from SMC/Parents</li>
                      <li>Mr. Gurdev Singh : Retired Professor</li>
                      <li>Chirag : Student Representative (Science Stream)</li>
                      <li>Ritika : Student Representative (Arts Stream)</li>
                      <li>Simran : Student Representative (Commerce Stream)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 04. Refreshment Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Refreshment Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Prof. Gurjeet Kaur</li>
                      <li>Dr. Butta Ram</li>
                      <li>Prof. Ramesh Kumar</li>
                      <li>Ms. Jyoti Sharma</li>
                      <li>Sh. Ram Kumar</li>
                      <li>Sh. Vijay Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 05. Building Fund Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Building Fund Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Sunita Goyal, Principal : Chairperson</li>
                      <li>Dr. Uma Rani (Senior Most Teacher)</li>
                      <li>Pradhan Gran Panchayat Beetan</li>
                      <li>P.T.A. President</li>
                      <li>J.E (Nominated Member through Xen HPPWD Una)</li>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Educational Mentor (Retd. Principal)</li>
                      <li>CSCA President</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 06. College Advisory Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">College Advisory Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                      <li>Sh. Rajeev Kumar (Supdt. G1)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 07. Sports and Cultural Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Sports and Cultural Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Anita Devi</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Ms. Jyoti Sharma</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 08. College Magazine Committee (Editorial Board) */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      College Magazine Committee (Editorial Board)
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>
                        Dr. Uma Rani : Chief Editor cum Editor Sanskrit Section
                      </li>
                      <li>Dr. Gaurav Sharma : English Section</li>
                      <li>Dr. Richa Sharma : Science Section</li>
                      <li>Dr. Anita Devi : Hindi Section</li>
                      <li>Ms. Gurjeet Kaur : Planning Section</li>
                      <li>Sh. Ramesh Kumar : Pahari Section</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 09. Anti-Ragging and General Discipline Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Anti-Ragging and General Discipline Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Anita Devi</li>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 10. Excursion / Educational Tour Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Excursion / Educational Tour Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Butta Ram</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* ... Remaining committees 11-43 follow same pattern ... */}

              {/* 11. Library Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Library Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                      <li>Sh. Pawan Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 12. RUSA 2.0/ PM USHA and UGC Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">RUSA 2.0/ PM USHA and UGC Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Sh. Ashok Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 13. CSCA Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">CSCA Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Dr. Anita Devi</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 14. Water/Electricity/Furniture/Building Repair and Maintenance Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Water/Electricity/Furniture/Building Repair and Maintenance
                      Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Butta Ram</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Sh. Rajeev Kumar (Supdt.-1)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 15. Mid Term Examination Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Mid Term Examination Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Mr. Gurmel Singh</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Sh. Pawan Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 16. Red Ribbon Club / Youth Red Cross / Road Safety / Gender Sensitization Cell / First Aid Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Red Ribbon Club / Youth Red Cross / Road Safety / Gender
                      Sensitization Cell / First Aid Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh (Red Ribbon Club)</li>
                      <li>Dr. Anita Devi (Road Safety Club)</li>
                      <li>Sh. Butta Ram (Youth Red Cross)</li>
                      <li>Ms. Jyoti Sharma (Gender Sensitization Cell)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 17. Disaster Management Committee and Anti Drug Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Disaster Management Committee and Anti Drug Cell
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Butta Ram</li>
                      <li>Ms. Jyoti Sharma</li>
                      <li>Sh. Pawan Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 18. SPARSH / Women Grievance Redressal Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      SPARSH / Women Grievance Redressal Cell
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Prof. Gurjeet Kaur</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 19. ECO Club / Campus Beautification and Cleanliness Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      ECO Club / Campus Beautification and Cleanliness Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                      <li>Sh. Karam Chand (Mali)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 20. Students Wellness and Counselling Cell / First-Aid Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Students Wellness and Counselling Cell / First-Aid Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Gurjeet Kaur</li>
                      <li>Ms. Jyoti Sharma</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* 21. Prospectus Committee, Online Admission Committee, Website Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Prospectus Committee, Online Admission Committee, Website
                      Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Richa Sharma</li>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 22. Scholarship / Fee Concession Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Scholarship / Fee Concession Committee
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Jyoti Sharma</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 23. Bus Pass Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Bus Pass Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Sh. Ashok Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 24. ABC / SWAYAM Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">ABC / SWAYAM Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh</li>
                      <li>Dr. Butta Ram</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 25. National Service Scheme (NSS) */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">National Service Scheme (NSS)</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Sh. Ashok Kumar (Storekeeper)</li>
                      <li>Sh. Karam Chand</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 26. Alumni / OSA Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Alumni / OSA Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Butta Ram</li>
                      <li>Sh. Rajeev Kumar (Supdt. G1)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 27. IT Cell / Cyber Safety Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">IT Cell / Cyber Safety Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Sh. Pawan Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 28. Equity Initiative Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Equity Initiative Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 29. Electoral Literacy Club / Energy Club */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Electoral Literacy Club / Energy Club</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Butta Ram (Nodal Officer)</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Ms. Jyoti Sharma</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 30. Time Table Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Time Table Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 31. Press and Photography */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Press and Photography</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Richa Sharma</li>
                      <li>Ms. Gurjeet Kaur</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 32. AISHE */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">AISHE</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Gurmel Singh</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 33. Rovers and Rangers Unit */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Rovers and Rangers Unit</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Butta Ram (In-charge Rovers Unit)</li>
                      <li>Ms. Jyoti Sharma (In-charge Rangers Unit)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 34. NEP Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">NEP Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Ms. Jyoti Sharma</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 35. National Cadet Corps: NCC Unit */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">National Cadet Corps: NCC Unit</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Sh. Ramesh Kumar (A.N.O)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 36. Bursar */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Bursar</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Ms. Gurret Kaur</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 37. PTA Secretary */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">PTA Secretary</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Ms. Gurjeet Kaur</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 38. Unnat Bharat / Ek Bharat / Shresht Bharat */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">
                      Unnat Bharat / Ek Bharat / Shresht Bharat
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Butta Ram</li>
                      <li>Sh. Ramesh Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 39. Canteen Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Canteen Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Butta Ram</li>
                      <li>Prof. Gurjeet Kaur</li>
                      <li>Prof. Jyoti Sharma</li>
                      <li>Sh. Ram Kumar</li>
                      <li>Sh. Vijay Kumar</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 40. Student Grievance Redressal Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Student Grievance Redressal Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani</li>
                      <li>Dr. Gaurav Sharma</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Chirag (CSCA President)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 41. Internal Complaint Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Internal Complaint Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Uma Rani (Presiding Officer)</li>
                      <li>Dr. Richa Sharma</li>
                      <li>Prof. Gurjeet Kaur</li>
                      <li>Ms. Sunita Rani (Librarian)</li>
                      <li>Sh. Rajeev Kumar (Supdt. Gd-1)</li>
                      <li>Mr. Gurdev Singh (Retired Prof.)</li>
                      <li>Chirag (B.SC 3rd Year)</li>
                      <li>Ritika (M.A 1st Sem.)</li>
                      <li>Sukhjeet Kaur (B.A 1st year)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 42. Best Practices and M.O.U. Committee */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Best Practices and M.O.U. Committee</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Dr. Anita Devi</li>
                      <li>Sh. Ramesh Kumar</li>
                      <li>Ms. Jyoti Sharma</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* 43. Equal Opportunity and SC/ST Cell */}
              <div className="col-md-6">
                <div className="committee-card">
                  <div className="card-header">
                    <h3 className="m-0">Equal Opportunity and SC/ST Cell</h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li>Chairperson: Dr. Sunita Goyal (Principal)</li>
                      <li>Dr. Daleep Bali (Member)</li>
                      <li>Sh. Butta Ram (Member)</li>
                      <li>Ms. Gurjeet Kaur (Adviser)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Committees;
